/* « Composez votre trio » — bundle composable (Vanille Désiré).

   Le client coche 3 produits, on ajoute les 3 lignes en UN SEUL appel
   POST /cart/add avec items[], puis on rejoue le tiroir panier maison via
   le pont public window.vdCart (assets/vd-yc.js).

   Honnêteté : la remise de -15 % n'est PAS calculée ici. Elle vient de la
   remise automatique Shopify « -15 % dès 3 articles » et s'applique au panier.
   On n'affiche donc le total remisé QU'UNE FOIS les 3 produits choisis, et
   jamais de prix barré sur une carte produit.

   i18n : toutes les chaînes arrivent en data-* posées par le Liquid (locales
   FR / EN / ES). Aucun texte en dur. */

if (!customElements.get('vd-yc-trio')) {
  customElements.define(
    'vd-yc-trio',
    class VdYcTrio extends HTMLElement {
      connectedCallback() {
        this.required = parseInt(this.dataset.required, 10) || 3;
        this.percent = parseFloat(this.dataset.percent) || 0;

        this.cards = Array.from(this.querySelectorAll('[data-vd-trio-card]'));
        this.slotsEl = this.querySelector('[data-vd-trio-slots]');
        this.countEl = this.querySelector('[data-vd-trio-count]');
        this.fullEl = this.querySelector('[data-vd-trio-full]');
        this.afterLineEl = this.querySelector('[data-vd-trio-after-line]');
        this.afterEl = this.querySelector('[data-vd-trio-after]');
        this.savingEl = this.querySelector('[data-vd-trio-saving]');
        this.saveEl = this.querySelector('[data-vd-trio-save]');
        this.addBtn = this.querySelector('[data-vd-trio-add]');

        if (!this.cards.length || !this.addBtn) return;

        this.addEventListener('change', (event) => {
          if (event.target.closest('[data-vd-trio-input]')) this.update();
          const select = event.target.closest('[data-vd-trio-variant]');
          if (select) this.syncVariant(select);
        });

        this.addEventListener('click', (event) => {
          const remove = event.target.closest('[data-vd-trio-slot-remove]');
          if (remove) {
            const card = this.cards[parseInt(remove.dataset.vdTrioSlotRemove, 10)];
            const input = card && card.querySelector('[data-vd-trio-input]');
            if (input) {
              input.checked = false;
              this.update();
            }
            return;
          }
          if (event.target.closest('[data-vd-trio-add]')) this.addToCart();
        });

        this.update();
      }

      /* Le sélecteur de variante pilote le prix et l'id de la carte. */
      syncVariant(select) {
        const card = select.closest('[data-vd-trio-card]');
        const option = select.options[select.selectedIndex];
        if (!card || !option) return;
        card.dataset.variantId = option.value;
        card.dataset.price = option.dataset.price || '0';
        const priceEl = card.querySelector('[data-vd-trio-card-price]');
        if (priceEl && option.dataset.priceFormatted) {
          priceEl.textContent = option.dataset.priceFormatted;
        }
        this.update();
      }

      selectedCards() {
        return this.cards.filter((card) => {
          const input = card.querySelector('[data-vd-trio-input]');
          return input && input.checked;
        });
      }

      formatMoney(cents) {
        const currency =
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency',
            currency: currency,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }
      }

      update() {
        const selected = this.selectedCards();
        const complete = selected.length === this.required;

        // Verrouille les cartes non cochées une fois le trio complet.
        this.cards.forEach((card) => {
          const input = card.querySelector('[data-vd-trio-input]');
          if (!input) return;
          const locked = complete && !input.checked;
          input.disabled = locked;
          card.classList.toggle('is-locked', locked);
          card.classList.toggle('is-selected', input.checked);
        });

        const full = selected.reduce(
          (sum, card) => sum + (parseInt(card.dataset.price, 10) || 0),
          0
        );
        const after = Math.round((full * (100 - this.percent)) / 100);

        if (this.countEl) this.countEl.textContent = String(selected.length);
        if (this.fullEl) this.fullEl.textContent = selected.length ? this.formatMoney(full) : '—';

        // Le total remisé n'a de sens qu'à 3 articles : la remise automatique
        // ne se déclenche pas avant. On le masque tant que le trio est partiel.
        if (this.afterLineEl) this.afterLineEl.hidden = !complete;
        if (this.afterEl) this.afterEl.textContent = complete ? this.formatMoney(after) : '—';
        if (this.savingEl) this.savingEl.hidden = !complete;
        if (this.saveEl) this.saveEl.textContent = this.formatMoney(full - after);

        this.addBtn.disabled = !complete;
        this.renderSlots(selected);
      }

      renderSlots(selected) {
        if (!this.slotsEl) return;
        this.slotsEl.textContent = '';
        for (let index = 0; index < this.required; index += 1) {
          const card = selected[index];
          const slot = document.createElement('li');
          slot.className = 'vd-trio__slot';

          if (!card) {
            slot.classList.add('vd-trio__slot--empty');
            slot.setAttribute('aria-label', this.dataset.i18nEmptySlot || '');
            this.slotsEl.appendChild(slot);
            continue;
          }

          const image = card.dataset.image;
          if (image) {
            const img = document.createElement('img');
            img.src = image;
            img.alt = card.dataset.title || '';
            img.width = 40;
            img.height = 40;
            img.loading = 'lazy';
            img.className = 'vd-trio__slot-img';
            slot.appendChild(img);
          } else {
            const fallback = document.createElement('span');
            fallback.className = 'vd-trio__slot-text';
            fallback.textContent = (card.dataset.title || '').slice(0, 2).toUpperCase();
            slot.appendChild(fallback);
          }
          slot.title = card.dataset.title || '';

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'vd-trio__slot-remove';
          remove.dataset.vdTrioSlotRemove = String(this.cards.indexOf(card));
          const removeLabel = this.dataset.i18nRemove || '';
          remove.setAttribute(
            'aria-label',
            card.dataset.title ? removeLabel + ' : ' + card.dataset.title : removeLabel
          );
          remove.textContent = '×';
          slot.appendChild(remove);

          this.slotsEl.appendChild(slot);
        }
      }

      async addToCart() {
        const selected = this.selectedCards();
        if (selected.length !== this.required) return;

        const items = selected
          .map((card) => ({ id: parseInt(card.dataset.variantId, 10), quantity: 1 }))
          .filter((item) => Number.isFinite(item.id));
        if (items.length !== this.required) return;

        const label = this.addBtn.textContent;
        this.addBtn.disabled = true;
        this.addBtn.textContent = (this.dataset.i18nAdding || '') + '…';

        try {
          const response = await fetch(
            (window.routes && window.routes.cart_add_url) || '/cart/add',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items }),
            }
          );
          const parsed = await response.json().catch(() => null);
          if (!response.ok || (parsed && parsed.status)) {
            throw new Error((parsed && (parsed.description || parsed.message)) || response.status);
          }

          // Trio consommé : on repart d'une sélection vide.
          this.cards.forEach((card) => {
            const input = card.querySelector('[data-vd-trio-input]');
            if (input) input.checked = false;
          });
          this.update();

          if (window.vdCart) {
            await window.vdCart.refresh();
            window.vdCart.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        } catch (error) {
          console.error('[vd-yc-trio]', error);
          window.alert(this.dataset.i18nError || '');
        } finally {
          this.addBtn.textContent = label;
          this.update();
        }
      }
    }
  );
}
